// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import HoverButton from './HoverButton'
import EditIcon from '@mui/icons-material/Edit';
import ColorConstants from 'constants/ColorConstants'

const glyphIcons = {
  pencil: EditIcon,
};

// Explicit testids: MUI only auto-adds data-testid in development builds,
// and the Cypress suite selects these icons against production packs.
const glyphTestIds = {
  pencil: 'EditIcon',
};

function GlyphHoverButton(props) {
  const GlyphIcon = glyphIcons[props.glyph];
  return <HoverButton
    show={props.show}
    onClick={props.onClick}
    className={props.className}
  >
    {GlyphIcon && <GlyphIcon
      data-testid={glyphTestIds[props.glyph]}
      style={{
          display: "block",
          color:ColorConstants.LIGHT_GREY,
          fontSize: 18}}
    />}
  </HoverButton>
}

export default GlyphHoverButton;
